import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const ComfortIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M6.67,3.56,8.2,7.87h7.2l1.47-4.31ZM4.94,3.32A1,1,0,0,1,5.87,2h11.8a1,1,0,0,1,.93,1.31L16.74,8.76a1,1,0,0,1-.93.67h-8a1,1,0,0,1-.94-.66Z" />
      <path d="M16.69,15.38a1,1,0,0,1,.32.76.86.86,0,0,1-.37.68A8.13,8.13,0,0,1,14.39,18a8.4,8.4,0,0,1-2.62.41,8.05,8.05,0,0,1-4.88-1.6.8.8,0,0,1-.36-.68,1,1,0,0,1,.32-.75,1.11,1.11,0,0,1,.76-.31,1.57,1.57,0,0,1,.84.24A5.79,5.79,0,0,0,10,16a6.06,6.06,0,0,0,1.77.26A5.66,5.66,0,0,0,13.54,16a5.87,5.87,0,0,0,1.54-.72,1.47,1.47,0,0,1,.85-.24A1.15,1.15,0,0,1,16.69,15.38Zm3.13,3a1,1,0,0,1,.31.73.89.89,0,0,1-.33.71,12.9,12.9,0,0,1-3.68,2.07,12.47,12.47,0,0,1-4.35.75,12.51,12.51,0,0,1-4.35-.75A12.85,12.85,0,0,1,3.75,19.8a.9.9,0,0,1-.34-.7,1,1,0,0,1,.32-.74A1.12,1.12,0,0,1,4.49,18a1.29,1.29,0,0,1,.82.26,10.54,10.54,0,0,0,6.46,2.21,10.59,10.59,0,0,0,6.47-2.21,1.25,1.25,0,0,1,.81-.26A1.14,1.14,0,0,1,19.82,18.36Zm-8-7a1.45,1.45,0,0,1,1.05.4,1.41,1.41,0,0,1,0,2,1.57,1.57,0,0,1-2.09,0,1.39,1.39,0,0,1,0-2A1.44,1.44,0,0,1,11.77,11.35Z" />
    </SvgIcon>
  )
}
export default ComfortIcon
